import {Select as MaterialSelect} from "@mui/material";
import React from "react";

import scss from "./Select.module.scss";

/**
 * Select component
 *
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class Select extends React.PureComponent {

	/**
	 * Component mounted.
	 * 
	 * @return {void}
	 */
	componentDidMount() {
		if (this.props.reportDefaultValue) {
			this.reportChange(this.props.defaultValue);
		}
	}


	/**
	 * Change handler.
	 * 
	 * @param {Event} e
	 * @return {void}
	 */
	handleChange = e => {

		let value = e.target.value;

		if (this.props.matchValue) {
			if (!isNaN(value)) value = parseInt(value);
			value = this.props.matchValue(value);
		}

		this.reportChange(value);

	};


	/**
	 * Report a change.
	 * 
	 * @param {mixed} value
	 * @return {void}
	 */
	reportChange = value => {
		this.props.onChange(value, this.props.name);
	};


	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<MaterialSelect
				className={`${scss.select} ${(this.props.readOnly ? scss.readOnly : "")}`}
				color="secondary"
				disabled={((!this.props.options && !this.props.enabledWhenEmpty) || this.props.disabled || this.props.loading || this.props.readOnly || (this.filteredOptions?.length === 0))}
				native={true}
				onChange={this.handleChange}
				required={this.props.required}
				size={this.props.size}
				style={this.constructor.styles}
				value={(this.props.value || this.props.defaultValue || "")}
				variant={this.props.variant}>
				{
					this.options?.map((option, key) => (
						<option
							disabled={(option.disabled || (this.props.getOptionDisabled && this.props.getOptionDisabled(option)))}
							key={key}
							value={(option.internal ? "" : (this.props.getOptionValue ? this.props.getOptionValue(option) : (option.value || "")))}>
							{(option.internal ? option.label : (this.props.getOptionLabel ? this.props.getOptionLabel(option) : (option.label || "")))}
						</option>
					))
				}
			</MaterialSelect>
		);
	}


	/**
	 * Get the default (placeholder) option definition.
	 *
	 * @return {Object|undefined}
	 */
	get defaultOption() {
		if (this.props.label && this.props.showDefaultOption) {
			return {
				label: this.props.label,
				disabled: true,
				value: null
			};
		}
		else return undefined;
	}


	/**
	 * Get filtered options to render.
	 *
	 * @return {Array}
	 */
	get filteredOptions() {
		return this.props.options?.filter(o => !o.hidden);
	}


	/**
	 * Get our options array.
	 * 
	 * @return {Array}
	 */
	get options() {

		const options = this.filteredOptions;

		if (options?.length) {
			const defaultOption = this.defaultOption;
			if (defaultOption) options.unshift(defaultOption);
			return options;
		}
		else if (options?.length === 0) {
			return [{label: (this.props.noOptionsLabel || "No options available."), internal: true, disabled: true}];
		}
		else if ((this.props.options === null) || this.props.error) {
			return [{label: (this.props.errorLabel || `${this.props.defaultValueLabel} (Error)`), internal: true}];
		}
		else {
			return [{label: (this.props.loadingLabel || `${this.props.defaultValueLabel} (Loading...)`), internal: true}];
		}

	}

}

export default Select;
